import type { Feature } from '@luna/gatekeeper';

export const permanentLimits: Feature = {
    enabled: true,
    _description:
        'Enables permanent limits feature display on the bank card settings page, card features page and supplementary card settings page',
};
